/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LotMetricsDto } from '../../models/lot-metrics-dto';

export interface GetLotMetrics$Params {
  fromDate?: string;
  toDate?: string;
  'X-API-Version'?: string;
}

export function getLotMetrics(http: HttpClient, rootUrl: string, params?: GetLotMetrics$Params, context?: HttpContext): Observable<StrictHttpResponse<LotMetricsDto>> {
  const rb = new RequestBuilder(rootUrl, getLotMetrics.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LotMetricsDto>;
    })
  );
}

getLotMetrics.PATH = '/api/metrics/lots';
